import React from "react";

const DEFAULT_PAYMENT_METHODS = [
  { name: "American Express", logo: "/payment-logos/americanexpress.png" },
  { name: "Banco Agrario", logo: "/payment-logos/bancoagrario.jpg" },
  { name: "Banco de Bogota", logo: "/payment-logos/bancodebogota.jpg" },
  { name: "Bancolombia", logo: "/payment-logos/bancolombia.svg" },
  { name: "Banco de Occidente", logo: "/payment-logos/bancooccidente.png" },
  { name: "Davivienda", logo: "/payment-logos/davivienda.png" },
  { name: "JFK", logo: "/payment-logos/jfk.png" },
  { name: "Maestro", logo: "/payment-logos/maestro.svg" },
  { name: "Mastercard", logo: "/payment-logos/mastercard.png" },
  { name: "Nequi", logo: "/payment-logos/nequi.png" },
  { name: "PSE", logo: "/payment-logos/pse.jpg" },
];

const PaymentMethodsBanner = ({ extraMethods = [] }) => {
  const customMethods = Array.isArray(extraMethods)
    ? extraMethods.filter((item) => item && item.logo)
    : [];

  const methods = [...DEFAULT_PAYMENT_METHODS, ...customMethods];
  const marqueeMethods = [...methods, ...methods];

  return (
    <section className="payment-banner border-y border-black/10 bg-[#f8f8f8]">
      <div className="container mx-auto px-4 py-10">
        <h3 className="payment-banner-title text-center text-[22px] font-semibold text-black">
          Metodos de pago aceptados
        </h3>

        <div className="payment-banner-marquee mt-6">
          <div className="payment-marquee-track">
            {marqueeMethods.map((method, index) => (
              <div key={`${method.name}-${index}`} className="payment-method-chip">
                <img
                  src={method.logo}
                  alt={method.name}
                  className="payment-method-logo"
                  loading="lazy"
                  decoding="async"
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                    const fallback = event.currentTarget.nextSibling;
                    if (fallback) fallback.style.display = "inline-flex";
                  }}
                />
                <span className="payment-method-fallback">{method.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentMethodsBanner;
